import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    TextFill,
    tfmixin
} from './vue/components/text-fill/TextFill.vue';

import lazyload from './features/lazy-load';
import proportionalScroll from './features/proportional-scroll';


lazyload();
proportionalScroll();
const mixins = [];
mixins.push(tfmixin);

initMain(mixins, {
    TextFill,
    SectionPager: () => import('./vue/components/section-pager/SectionPager.vue'),
    MiniQuoteGraph: () => import('./vue/components/mini-quote-graph/MiniQuoteGraph.vue'),
    NewsStandRipe: () => import('./vue/components/news-stand-ripe/NewsStandRipe.vue'),
    TrendsHorizontal: () => import('./vue/components/trends/TrendsHorizontal.vue')
});
header();